// src/packages/viriyah/motor/viriyah_ev_type1_2to5/EVType1Details.jsx
import React from "react";
import "./ev_type1.css";

export default function EVType1Details({ onQuote }) {
  // เบี้ยรวม (รวมภาษี) สำหรับตัวขายดี — คัดจากเอกสารอัตราเบี้ย
  const rows = [
    { model: "BYD ATTO 3",    fund: "770,000–940,000",     premium: "28,000" },
    { model: "ORA Good Cat",  fund: "500,000–980,000",     premium: "26,900" },
    { model: "MG ZS EV",      fund: "760,000–890,000",     premium: "24,900" },
    { model: "NETA V",        fund: "350,000–420,000",     premium: "19,900" },
    { model: "TESLA Model Y", fund: "1,300,000–1,550,000", premium: "63,900" },
    { model: "TESLA Model 3", fund: "1,200,000–1,450,000", premium: "63,900" },
    { model: "VOLVO XC40",    fund: "1,300,000–1,550,000", premium: "51,000" },
    { model: "BMW i3",        fund: "2,400,000–2,800,000", premium: "73,900" },
  ];

  return (
    <div className="pkg-detail viriyah-ev">
      <h2>EV ประเภท 1 (2–5 ปี) — ซ่อมห้าง | วิริยะประกันภัย</h2>
      <p>สรุปแพ็กเกจรุ่นขายดีและช่วงทุนตัวอย่าง (เบี้ยรวม/ปี)</p>

      <table className="pkg-table">
        <thead>
          <tr>
            <th>รุ่นรถ</th>
            <th>ช่วงทุนประกัน (บาท)</th>
            <th>เบี้ยรวม (บาท/ปี)</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={`${r.model}-${r.fund}`}>
              <td>{r.model}</td>
              <td>{r.fund}</td>
              <td>{r.premium}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="pkg-foot">
        <p>
          * เบี้ยข้างต้นรวมส่วนลด CCTV และแอปแจ้งเหตุแล้ว • กำหนดทุน ~80% ของราคารถ •
          กรณีมีชุดแต่งเพิ่ม อาจมีการปรับเบี้ยตามเงื่อนไขบริษัท
        </p>
        <p>
          * แผน EV ต้องระบุชื่อผู้ขับขี่อย่างน้อย 1 คน สูงสุด 5 คน (ตามประกาศ คปภ.) —
          อ้างอิงเอกสารอัตราเบี้ยวิริยะ EV 2–5 ปี (ชั้น 1)
        </p>
        <button className="pkg-quote-btn" onClick={onQuote} aria-label="ขอใบเสนอราคา">
          ขอใบเสนอราคา
        </button>
      </div>
    </div>
  );
}
